import type {
  CancelTournamentRequest,
  CancelTournamentResponse,
  CancelTournamentResponseV0
} from '@ps/web-shared-api-types/v0/SwHomeGames';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import useRequest from '@swf/core/hooks/useRequest';
import type { Dispatch } from '@swf/core/store';
import { ENDPOINTS, handleServerResponse, useHomeGamesWidget } from '@swf/poker';

import { ModalRoutes } from '../types/common';

export interface RequestBody {
  body: CancelTournamentRequest;
}

const useDeleteTournament = (widgetId?: string) => {
  const request = useRequest();
  const { modal } = useDispatch<Dispatch>();
  const [loading, setLoading] = useState(false);
  const { widgetDispatch } = useHomeGamesWidget(widgetId);

  const handleDeleteTournament = ({ body }: RequestBody) => {
    setLoading(true);
    request({ service: ENDPOINTS.cancelTournament, body, http: true, method: 'DELETE' })
      .pipe(catchError((err) => of(err)))
      .subscribe({
        next: ({ body }: { body: CancelTournamentResponse }) => {
          const { error } = handleServerResponse<
            CancelTournamentResponse,
            CancelTournamentResponseV0
          >({
            response: body,
            accessor: 'hgCancelTournamentReply'
          });
          setLoading(false);
          modal.close();

          if (error) {
            modal.enqueue({
              path: ModalRoutes.notification,
              locationState: { text: error }
            });
          } else {
            widgetDispatch.fetchClubInfo();
            window.starsweb?.homegames?.refresh?.();
          }
        }
      });
  };

  return { handleDeleteTournament, loading };
};

export default useDeleteTournament;
